function avviaInpostCountdown() {
  var bar = document.getElementById('inpost-promo-bar');
  if (!bar || bar._countdownAttivo) return;
  var fine = new Date(bar.getAttribute('data-scadenza')).getTime();
  var el = bar.querySelector('.inpost-countdown');
  var scaduta = bar.querySelector('.inpost-scaduta');
  if (!el || isNaN(fine)) return;
  bar._countdownAttivo = true;
  function tick() {
    var diff = fine - Date.now();
    if (diff <= 0) {
      el.style.display = 'none';
      scaduta.style.display = 'inline';
     bar.style.display = 'none';

      return;
    }
    var ore = Math.floor(diff / 3600000);
    var min = Math.floor((diff % 3600000) / 60000);
    var sec = Math.floor((diff % 60000) / 1000);
    el.textContent = ore + 'h ' + String(min).padStart(2,'0') + 'm ' + String(sec).padStart(2,'0') + 's';
    setTimeout(tick, 1000);
  }
  tick();
}
avviaInpostCountdown();
new MutationObserver(avviaInpostCountdown).observe(document.body, { childList: true, subtree: true });
